import React, {useState} from 'react'
import styled from 'styled-components'
import CSSKeys from './CSSPropertiesKeys'

export function CSSPreparation1(props) {

    var styling = {}; 
	//console.log("css",props);    
    if(props){
        var stylingData = props;
        Object.keys(stylingData).forEach((key) => {
                if(Object.keys(CSSKeys).includes(key)){
                    styling[CSSKeys[key]] = stylingData[key];
                }
                else {
                    styling[key] = stylingData[key];
                }
        })
     
    } 
    return (styling); 

}
